import { Grid, IconButton, InputAdornment } from '@mui/material'
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { useEffect, useState } from 'react'
import logo_buton from "assets/images/logo-buton.png"
import { CustomEncrypt } from 'global/func';
import Swal from 'sweetalert2';
import userStore from 'store/userStore';
import ArgonInput from 'components/ArgonInput';
import { LoadingButton } from '@mui/lab';
import { postDataWithResponse } from 'global/postFunc';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const Login = () => {
    const { setUser } = userStore((state) => ({ setUser: state.setUser }));
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        tahun_anggaran: '',
    })

    const [lokasi, setLokasi] = useState('')

    useEffect(() => {
        console.log(formData);
        console.log(lokasi);
    }, [formData, lokasi])

    useEffect(() => {
        getLocation()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [loading, setLoading] = useState(false)

    const auth = () => {
        if (formData.username === "") {
            Swal.fire("Oops!!", "Masukkan Username", "error")
            return
        }
        else if (formData.password === "") {
            Swal.fire("Oops!!", "Masukkan Password", "error")
            return
        }
        // else if (formData.tahun_anggaran === "") {
        //     Swal.fire("Oops!!", "Pilih Tahun Anggaran", "error")
        //     return
        // }

        postDataWithResponse(
            '/auth',
            {
                username: formData.username,
                password: formData.password,
                tahun_anggaran: formData.tahun_anggaran,
                location: lokasi
            },
            null,
            (res) => {
                responseHandling(res)
            },
            (res) => {
                setLoading(false)
            }
        )
    }

    const responseHandling = (params) => {
        let encrypted = CustomEncrypt(JSON.stringify(params));
        setUser(encrypted);
    }

    const getLocation = () => {
        if (!navigator.geolocation) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Geolocation is not supported by your browser'
            })
        } else {
            navigator.geolocation.getCurrentPosition((position) => {
                setLokasi(position.coords.latitude + ',' + position.coords.longitude)
            }, () => {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Unable to retrieve your location'
                })
            });
        }
    }

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Grid container>
            <Grid item xs={11} sm={8} md={6} lg={4} xl={3} sx={{ mx: "auto" }} pt={{ xs: 12, lg: 3 }}>
                <ArgonBox display="flex" flexDirection="column" justifyContent="center" height={{ lg: "100vh", xs: 'auto' }}>
                    <ArgonBox px={3}>
                        <ArgonBox mb={1}>
                            <ArgonTypography variant="h4" fontWeight="bold">
                                Sign In
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonTypography variant="body2" fontWeight="regular" color="text">
                            Masukkan Username dan Password
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox p={3}>
                        <ArgonBox component="form" role="form" autoComplete='off'>
                            <ArgonBox>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Username
                                    </ArgonTypography>
                                </ArgonBox>
                                {/* <TextField autoComplete='off' /> */}
                                <ArgonInput
                                    role='presentation'
                                    name='array[sdfsd]'
                                    type="text"
                                    placeholder="Username"
                                    size="medium"
                                    defaultValue={formData.username}
                                    onChange={(event) => setFormData({ ...formData, username: event.target.value })}
                                    autoComplete='off'
                                />
                            </ArgonBox>
                            <ArgonBox>
                                <ArgonBox mb={1} ml={0.5}>
                                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                        Password
                                    </ArgonTypography>
                                </ArgonBox>
                                <ArgonInput
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Password"
                                    size="medium"
                                    defaultValue={formData.password}
                                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                    autoComplete='off'
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                            >
                                                {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </ArgonBox>
                            <ArgonBox mt={4} mb={1}>
                                <LoadingButton variant="contained" color="info" fullWidth onClick={auth} loading={loading}>
                                    Sign In
                                </LoadingButton>
                            </ArgonBox>
                        </ArgonBox>
                    </ArgonBox>
                </ArgonBox>
            </Grid>
            <Grid item xs={12} lg={6}>
                <ArgonBox
                    display={{ xs: "none", lg: "flex" }}
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    width="calc(100% - 2rem)"
                    height="calc(100vh - 2rem)"
                    position="relative"
                    borderRadius="lg"
                    textAlign="center"
                    m={2}
                    px={13}
                    sx={{ overflow: "hidden" }}
                >
                    <ArgonBox
                        component="img"
                        src={logo_buton}
                        alt="background"
                        width="500px"
                        position="absolute"
                        top="calc(50vh - 250px)"
                        left="calc(50% - 250px)"
                    />
                    <ArgonBox
                        bgColor="warning"
                        // variant="primary"
                        width="100%"
                        height="100%"
                        position="absolute"
                        top={0}
                        left={0}
                        opacity={0.5}
                    />
                    <ArgonBox position="relative">
                        <ArgonBox mt={6} mb={1}>
                            <ArgonTypography variant="h4" color="white" fontWeight="bold">
                                Attention is the new currency
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonBox mb={1}>
                            <ArgonTypography variant="body2" color="white">
                                The more effortless the writing looks, the more effort the writer actually put into the process.
                            </ArgonTypography>
                        </ArgonBox>
                    </ArgonBox>
                </ArgonBox>
            </Grid>
        </Grid>
    )
}

Login.defaultProps = {
    color: "warning",
    header: "",
    title: "",
    description: "",
    button: { color: "info" },
    illustration: {},
};

// Typechecking props for the IllustrationLayout

export default Login